import { useScenarioStore } from "../state/useScenarioStore";

/**
 * Switch the active scenario without leaving the pane you are in.
 *
 * The scenario decides the flat's size, which sets the price, the taxe foncière
 * and the service charges — so costing a different one is a normal step in the
 * middle of looking at costs, not a reason to go back to another tab.
 *
 * A native select rather than the segmented control used elsewhere: the list
 * grows without bound, and this one stays one line at any length.
 */
export function ScenarioPicker({ label = "Scenario" }: { label?: string }) {
  const scenarios = useScenarioStore((s) => s.scenarios);
  const activeId = useScenarioStore((s) => s.activeId);
  const activate = useScenarioStore((s) => s.activate);

  // A persisted activeId can outlive the scenario it pointed at; fall back the
  // same way the store's `active()` does so the select never shows blank.
  const value = scenarios.some((s) => s.id === activeId)
    ? activeId
    : (scenarios[0]?.id ?? "");

  return (
    <label className="block">
      <span className="text-[10px] font-medium uppercase tracking-wider text-ink-soft">
        {label}
      </span>
      <span className="mt-0.5 flex items-center rounded border border-line bg-surface px-1.5 focus-within:border-accent">
        <select
          value={value}
          onChange={(e) => activate(e.target.value)}
          className="w-full min-w-0 cursor-pointer bg-transparent py-1 text-[12px] outline-none"
        >
          {scenarios.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name} · {s.surface} m² · {s.horizon} yr
            </option>
          ))}
        </select>
      </span>
    </label>
  );
}
